import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

// Mirrors pdf-visualizer.jsx's isSafeDocumentUrl.
const isSafeDocumentUrl = (value) =>
  typeof value === 'string' && (value.startsWith('https://') || value.startsWith('blob:'));

const pdfToImage = async (fileOrUrl) => {
  let loadOptions;
  if (isSafeDocumentUrl(fileOrUrl)) {
    loadOptions = { url: fileOrUrl };
  } else if (fileOrUrl instanceof ArrayBuffer) {
    loadOptions = { data: fileOrUrl };
  } else if (fileOrUrl && typeof fileOrUrl.arrayBuffer === 'function') {
    loadOptions = { data: await fileOrUrl.arrayBuffer() };
  } else {
    throw new Error('pdfToImage: unsupported input');
  }
  const pdf = await pdfjsLib.getDocument(loadOptions).promise;
  const page = await pdf.getPage(1);

  const scale = 1;
  const viewport = page.getViewport({ scale });

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({ canvasContext: context, viewport }).promise;

  return canvas.toDataURL('image/png');
};

export default pdfToImage;
